<template>
    <div class="grid-item no-flex">
        <v-popper position="bottomEnd">
            <div slot="trigger">
                <v-icon-button :disabled="disabled || !event.hasEmailTemplates" v-popper-trigger class="inline-s" type="basic">
                    <v-icon icon="event"/>
                    Merge Content
                </v-icon-button>
            </div>
            <div class="dropdown" slot="content">
                <div class="dropdown-content dropdown-content-help">
                    Insert premade HTML content
                </div>

                <div class="dropdown-content">
                    <div
                        class="dropdown-item"
                        v-for="(item, index) in event.emailTemplates"
                        @click="$emit('merge-content', item)"
                        :key="index">{{item.label}}
                    </div>
                </div>

            </div>
        </v-popper>
    </div>
</template>

<script>
    import EventModel from '@/common/models/rules/event-model';
    import {vIcon, vIconButton} from '@/components/form';
    import vPopper from '@/components/v-popper';

    export default {
        name: 'merge-content',
        components: {vIcon, vIconButton, vPopper},
        props: {
            disabled: Boolean,
            event: {
                type: EventModel,
            },
        },
    };
</script>

<style scoped></style>
